module.exports = __webpack_public_path__ + "img/day20.6cbfd0d9.jpeg";